export const RESERVATION_CHECK_CONFIRMATION_DAYS = 6;

export const RESERVATION_CHECK_LIST_STATUS = {
  BEFORE_COMING: 1,
  STATUS_TODAY: 2,
  BEFORE_CONFIRMATION: 3,
  CONFIRMED: 4,
};

export const RESERVATION_CHECK_LIST_STATUS_LABELS = {
  [RESERVATION_CHECK_LIST_STATUS.BEFORE_COMING]: '来店前',
  [RESERVATION_CHECK_LIST_STATUS.STATUS_TODAY]: '本日の予約',
  [RESERVATION_CHECK_LIST_STATUS.BEFORE_CONFIRMATION]: '確定前',
  [RESERVATION_CHECK_LIST_STATUS.CONFIRMED]: '確定済',
};

export const RESERVATION_STATUS_LABELS = {
  RESERVED: '【予約中】',
  ARRIVAL: '【来店済み】',
  CANCELLED: '【予約キャンセル】',
};
